import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Member, MembersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class MembersDataService {

  private uri: string = `${environment.apiUrl}members`;
  private cacheKey: string = 'members.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getMember(id: number): Observable<Member|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getMembers(parameters: {[param: string]: string | string[]}): Observable<MembersResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addMember(data: Member): Observable<Member|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addMembers(data: Member[]): Observable<Member[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateMember(data: Member): Observable<Member|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateMembers(data: Member[]): Observable<Member[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchMember(data: Member): Observable<Member|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchMembers(data: Member[]): Observable<Member[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteMember(data: Member): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteMembers(data: Member[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((member) => {
      ids.push(member.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
